import React from 'react'
import { useStateContext } from '@zambezi/caballo-vivo'
import { followStoreLink$ } from '../navigation'
import style from './OverviewCard.module.css'
import classNames from 'classnames'

const OverviewCard = ({ path, title, message, type, empty, icon }) => {
  const brandId = useStateContext().getIn(['brand', 'id'])

  return empty ? (
    <div className={style.emptyCard} />
  ) : (
    <button
      className={`zb-feature-button ${style.card} js-card-${type} ${style[type]}`}
      disabled={!path}
      onClick={() => followStoreLink$.next(path)}
    >
      <div>
        <div className={classNames([style.icon, style[brandId + 'Icon']])}>
          {icon}
        </div>
        <h2 className={`${style.title} js-title`}>{title}</h2>
      </div>
      <p className={`${style.message} js-message`}>{message}</p>
    </button>
  )
}

export default OverviewCard
